/* eslint-disable prettier/prettier */
export const API_REGISTER_CHECK_REF = process.env.REACT_APP_API_REGISTER_CHECK_REF
export const API_REGISTER_CHECK_CODE = process.env.REACT_APP_API_REGISTER_CHECK_CODE
export const API_REGISTER = process.env.REACT_APP_API_REGISTER

export const API_LOGIN = process.env.REACT_APP_API_LOGIN
export const API_LOGOUT = process.env.REACT_APP_API_LOGOUT

export const API_SEND_OTP = process.env.REACT_APP_API_SEND_OTP
export const API_VERIFY_OTP = process.env.REACT_APP_API_VERIFY_OTP

export const API_PASSWORD_FORGOT = process.env.REACT_APP_API_PASSWORD_FORGOT
export const API_PASSWORD_RESET = process.env.REACT_APP_API_PASSWORD_RESET

export const API_LESSOR_NAME_LIST = process.env.REACT_APP_API_LESSOR_NAME_LIST
export const API_LESSOR_COMPANY_LIST = process.env.REACT_APP_API_LESSOR_COMPANY_LIST
export const API_LESSOR_VENDOR_LIST = process.env.REACT_APP_API_LESSOR_VENDOR_LIST
export const API_LESSOR_CONTRACT_LIST = process.env.REACT_APP_API_LESSOR_CONTRACT_LIST
export const API_LESSOR_INFO = process.env.REACT_APP_API_LESSOR_INFO
export const API_LESSOR_UPDATE = process.env.REACT_APP_API_LESSOR_UPDATE
export const API_LESSOR_VERIFY = process.env.REACT_APP_API_LESSOR_VERIFY

export const API_PROFILE = process.env.REACT_APP_API_PROFILE
export const API_PROFILE_CHANGE_PASSWORD = process.env.REACT_APP_API_PROFILE_CHANGE_PASSWORD
export const API_PROFILE_VALIDATE_PASSWORD = process.env.REACT_APP_API_PROFILE_VALIDATE_PASSWORD
export const API_PROFILE_UPLOAD_AVATAR = process.env.REACT_APP_API_PROFILE_UPLOAD_AVATAR
export const API_PROFILE_DOWNLOAD_AVATAR = process.env.REACT_APP_API_PROFILE_DOWNLOAD_AVATAR

export const API_PAYMENT_LIST_BY_CONTRACT = process.env.REACT_APP_API_PAYMENT_LIST_BY_CONTRACT
export const API_PAYMENT_LIST_EXPORT = process.env.REACT_APP_API_PAYMENT_LIST_EXPORT
export const API_PAYMENT_INFO = process.env.REACT_APP_API_PAYMENT_INFO
export const API_PAYMENT_CONTRACT_INFO = process.env.REACT_APP_API_PAYMENT_CONTRACT_INFO
export const API_PAYMENT_CONTRACT_SUMMARY = process.env.REACT_APP_API_PAYMENT_CONTRACT_SUMMARY
export const API_PAYMENT_CONFIRM_RECEIVED = process.env.REACT_APP_API_PAYMENT_CONFIRM_RECEIVED
export const API_PAYMENT_OR_LIST = process.env.REACT_APP_API_PAYMENT_OR_LIST
export const API_PAYMENT_OR_UPLOAD = process.env.REACT_APP_API_PAYMENT_OR_UPLOAD
export const API_PAYMENT_OR_DOWNLOAD = process.env.REACT_APP_API_PAYMENT_OR_DOWNLOAD
export const API_PAYMENT_OR_REMOVE = process.env.REACT_APP_API_PAYMENT_OR_REMOVE
export const API_PAYMENT_POP_DOWNLOAD = process.env.REACT_APP_API_PAYMENT_POP_DOWNLOAD
export const API_PAYMENT_EXPORT = process.env.REACT_APP_API_PAYMENT_EXPORT

export const API_ECWT_LIST = process.env.REACT_APP_API_ECWT_LIST
export const API_ECWT_DOWNLOAD = process.env.REACT_APP_API_ECWT_DOWNLOAD
export const API_ECWT_INFO = process.env.REACT_APP_API_ECWT_INFO
export const API_ECWT_ACKNOWLEDGE = process.env.REACT_APP_API_ECWT_ACKNOWLEDGE

export const API_HS_LIST = process.env.REACT_APP_API_HS_LIST
export const API_HS_DOWNLOAD = process.env.REACT_APP_API_HS_DOWNLOAD
export const API_HS_DOWNLOAD_MP4 = process.env.REACT_APP_API_HS_DOWNLOAD_MP4

export const API_NOTIFICATION_LIST = process.env.REACT_APP_API_NOTIFICATION_LIST

export const API_ANNOUNCEMENT_LIST = process.env.REACT_APP_API_ANNOUNCEMENT_LIST
export const API_ANNOUNCEMENT_INFO = process.env.REACT_APP_API_ANNOUNCEMENT_INFO
export const API_ANNOUNCEMENT_DOWNLOAD_FILE = process.env.REACT_APP_API_ANNOUNCEMENT_DOWNLOAD_FILE

export const API_TICKET_OPEN_LIST = process.env.REACT_APP_API_TICKET_OPEN_LIST
export const API_TICKET_CLOSED_LIST = process.env.REACT_APP_API_TICKET_CLOSED_LIST
export const API_TICKET_CATEGORY_LIST = process.env.REACT_APP_API_TICKET_CATEGORY_LIST
export const API_TICKET_UPLOAD_FILE = process.env.REACT_APP_API_TICKET_UPLOAD_FILE
export const API_TICKET_CREATE = process.env.REACT_APP_API_TICKET_CREATE
export const API_TICKET_INFO = process.env.REACT_APP_API_TICKET_INFO
export const API_TICKET_DOWNLOAD_ATTACH = process.env.REACT_APP_API_TICKET_DOWNLOAD_ATTACH
export const API_TICKET_TAG_AS_RESOLVED = process.env.REACT_APP_API_TICKET_TAG_AS_RESOLVED
export const API_TICKET_COMMENT_CREATE = process.env.REACT_APP_API_TICKET_COMMENT_CREATE
export const API_TICKET_COMMENT_LIST = process.env.REACT_APP_API_TICKET_COMMENT_LIST
export const API_TICKET_COMMENT_UPLOAD_FILE = process.env.REACT_APP_API_TICKET_COMMENT_UPLOAD_FILE
export const API_TICKET_COMMENT_DOWNLOAD_FILE = process.env.REACT_APP_API_TICKET_COMMENT_DOWNLOAD_FILE
